export default "__VITE_ASSET__f0595f35__"